import {Component, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxRadioGroupModule, DxSelectBoxModule, DxValidatorModule} from "devextreme-angular";
import {AssetType, DataSources, MachineAttachmentCheckDto} from "@services";
import {YES_NO_OPTIONS} from "src/app/shared/constants";

@Component({
    selector: 'app-machine-attachment-check',
    standalone: true,
    imports: [
        CommonModule,
        DxSelectBoxModule,
        DxRadioGroupModule,
        DxValidatorModule
    ],
    templateUrl: './machine-attachment-check.component.html',
    styles: []
})
export class MachineAttachmentCheckComponent implements OnChanges {
    private dataSourcesService = inject(DataSources);

    @Input({required: true}) label!: string;
    @Input() attachmentId?: string | null;
    @Input({required: true}) assetType!: AssetType;
    @Input({required: true}) model!: MachineAttachmentCheckDto;
    @Input() readOnly = false;

    protected dataSource: any;

    protected yesNoOptions = YES_NO_OPTIONS;

    validateYesNo(params: { value: any }): boolean {
        return params.value !== null && params.value !== undefined;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes['attachmentId'] || changes['model']) && this.model) {
            this.model.attachedAssetId = this.attachmentId || undefined;
        }

        if (changes['assetType'] && this.assetType) {
            this.dataSource = this.dataSourcesService.assetOptions(this.assetType, false);
        }
    }
}
